<template lang='pug' src='./custom-home-contests.pug'></template>

<script>
import ContestsSliderDirective from './custom-home-contests.directive'

export default {
  props: ['content'],
  directives: {
    ContestsSliderDirective
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-contests.vue?8ebb399a